// src/hooks/useDeviceId.ts
import { useEffect, useState } from "react";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

const useDeviceId = () => {
  const [deviceId, setDeviceId] = useState<string | null>(null);

  useEffect(() => {
    const loadFingerprint = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      setDeviceId(result.visitorId); // a unique device fingerprint
    };

    loadFingerprint();
  }, []);

  return deviceId;
};

export default useDeviceId;
